module.exports = __webpack_public_path__ + "a8b0873bff573d0cc1c4593e6ff9f8e5.png";